import $ from 'jquery'
import '../plugins/owl.carousel'
import '../plugins/featherlight'
import '../plugins/featherlight.gallery'

$('.gallery .pictures').owlCarousel({
  loop: false,
  nav: true,
  navText: ['', ''],
  dots: false,
  items: 3,
});

$('.gallery a').featherlightGallery();



// WEBPACK FOOTER //
// ./src/js/components/gallery.js